import { type ReactElement } from 'react';
import { s } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import { ProjectSelectOptionContent } from './ProjectSelectOptionContent';
import type { ProjectDto } from '@flowqa/shared';

type ProjectFilterOptionContent = {
  label: string;
  badgeChars?: ProjectDto['badgeChars'];
  badgeColor?: ProjectDto['badgeColor'];
  badgeEnabled?: boolean;
  locked?: boolean;
  lockReason?: string | null;
};

export const renderProjectFilterOptionLabel = (
  option: ProjectFilterOptionContent,
): ReactElement => (
  <Box sx={{ minWidth: 0, pl: `calc((${s('xs')} + ${s('sm')}) / 2)`, width: '100%' }}>
    <ProjectSelectOptionContent
      contentGap={`calc((${s('sm')} + ${s('md')}) / 2)`}
      project={{
        name: option.label,
        badgeEnabled:
          option.badgeEnabled === true &&
          option.badgeChars !== undefined &&
          option.badgeColor !== undefined,
        badgeChars: option.badgeChars ?? option.label,
        badgeColor: option.badgeColor ?? 'teal',
        locked: option.locked,
        lockReason: option.lockReason,
      }}
    />
  </Box>
);
